import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PurchasingItemCategoryActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/ItemCategory/ItemCategoryBrowser")
	}

	render() {
		return (
			<Activity 
				name="PurchasingItemCategory"
				RenderedComponent={this.RenderedComponent}
				context="PurchasingItemCategory"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PurchasingItemCategoryActivity)
